import React from 'react';
import UserCard2 from 'components/Shared/UserCard2/UserCard2';
import Panel from 'components/Panel/Panel';
import userCardStyles from 'components/Shared/UserCard2/UserCard2.module.scss';

const BrowseUserCard2 = ({ collaborations, onInvite, user, preferredRole }) => {
  return (
    <Panel className={userCardStyles.gridContainer}>
      <UserCard2
        collaborations={collaborations}
        onInvite={onInvite}
        user={user}
        preferredRole={preferredRole}
      />
    </Panel>
  );
};

export default BrowseUserCard2;
